export const firebaseConfig = {
    "projectId": "great-lake-1b8f7",
    "appId": "1:739579527563:web:0f0d82738de839b5b92f8e",
    "storageBucket": "great-lake-1b8f7.firebasestorage.app",
    "apiKey": "AIzaSyDNCO2m6BrILNpnTLVfkLfxVJLW13WrWDA",
    "authDomain": "great-lake-1b8f7.firebaseapp.com",
    "messagingSenderId": "739579527563"
}